module.exports = __webpack_public_path__ + "img/Componente 48 – 1.7b4f12da.svg";